import { IApplicationState } from '../../../types/types';
import { ERoutes } from '../constants';

export const isBoardFilterPanelOpened = (
    state: IApplicationState
): boolean => {
    const { route } = state.router;
    return route === ERoutes.BOARD_FILTER;
}
